<template>
  <el-container style="height: 100%" class="ekt-warp">
    <el-alert v-if="browserCheckInfo" class="color-red" :title="browserCheckInfo" type="info" center show-icon>
    </el-alert>
    <el-container class="ekt-content">
      <el-aside width="" :class="['ekt-content-menu', getCollapseClass]">
        <Menu @toggleMenu="toggleMenu" :isAdminPage="+isAdminPage"/>
      </el-aside>
      <el-main class="ekt-content-main">
        <TabBar />
        <!-- 全局嵌入的抽屉 -->
        <el-drawer
          :class="getDModalVal ? '' : 'drawer-model'"
          custom-class="global-drawer"
          :modal="getDModalVal"
          :title="drawerInfo.title"
          :append-to-body="false"
          :modal-append-to-body="false"
          :visible.sync="drawerInfo.drawerShow"
          :destroy-on-close="true"
          :with-header="!!drawerInfo.title"
          :size="drawerInfo.drawerWidth"
          @close="closeDrawer"
        >
          <iframe
            v-if="drawerInfo.drawerSrc"
            :src="drawerInfo.drawerSrc"
            allowfullscreen
            :name="drawerInfo.title"
            width="100%"
            height="100%"
            border="0"
          ></iframe>
        </el-drawer>

        <el-dialog
          :title="dialogInfo.title"
          :visible.sync="dialogInfo.visible"
          :width="`${dialogInfo.width}px`"
          custom-class="global-dialog"
        >
          <iframe
            :src="dialogInfo.src"
            width="100%"
            :height="`${dialogInfo.height || '100%'}`"
            border="0"
          ></iframe>
        </el-dialog>
      </el-main>
      <div class="fix-menu" v-if="floatBarMenu.length > 0">
        <template v-for="item in floatBarMenu">
          <el-tooltip
            :key="item.name"
            class="item"
            effect="dark"
            :content="item.name"
            placement="left"
          >
            <span class="fix-btn-item" @click="fixMenuHandle(item)">
              <i :class="['iconfont', item.icon]"></i>
            </span>
          </el-tooltip>
        </template>

        <span class="fix-btn-item main">
          <i class="iconfont icon-quanbu-line"></i>
        </span>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Menu from "@/view/Home/menu";
import TabBar from "@/view/Home/tabBar";
import { browserCheck } from "@/utils";
import qidianMixin from '@/mixins/qidian'

export default {
  name: "home",
  mixins:[qidianMixin],
  props: {
    isAdminPage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 是否展开子菜单
      isCollapse: true,
      browserCheckInfo: ""
    };
  },
  created(){
    // 企点-座席页面，打开页面弹窗
    if(location.hash.includes('qidian/agent')){
      this.topPostMsg('showFloatPage')
      this.topPostMsg('setFloatPageStyle', { width: 900, height: 50});
    }
  },
  mounted() {
    let { isChrome, isFirefox, isEdg, ActualVersion, ActualName } =
      browserCheck();

    if (isChrome || isFirefox || isEdg) {
      let versions = ActualVersion.split(".");
      if (versions[0] < 90) {
        this.browserCheckInfo = this.$t('home.browserUpgradeTip', { browser: ActualName, version: versions[0] });
      }
    } else {
      this.browserCheckInfo = this.$t('home.browserRecommendChrome', { browser: ActualName });
    }

    this._Bus.$on('_busToggleMenu',(flag)=>{
      console.log(flag,'_busToggleMenu')
      this.toggleMenu(flag)
    })
  },
  computed: {
    ...mapGetters([
      "drawerInfo",
      "dialogInfo",
      "activeTabKey",
      "tabData",
      "floatBarMenu",
    ]),
    getDModalVal() {
      const { options = undefined } = this.drawerInfo;
      if (options && options.hasOwnProperty("model")) {
        return options.model;
      }
      return true;
    },
    getCollapseClass() {
      return !this.isCollapse ? "collapse-active" : "collapse-close";
    }
  },
  components: {
    Menu: Menu,
    TabBar: TabBar,
  },
  methods: {
    ...mapActions(["changeDrawerInfo", "changeDialogInfo", "addTab"]),
    /**
     * 功能：展开收起子菜单
     * isCollapse: 1、不传递，切换展开收起状态；2、传递，根据值确定是否展开
     */
    toggleMenu(isCollapse) {
      this.isCollapse =
        isCollapse !== undefined ? isCollapse : !this.isCollapse;
    },
    // 关闭抽屉
    closeDrawer() {
      this.changeDrawerInfo({
        drawerShow: false,
        drawerSrc: "",
        drawerWidth: "0",
      });
    },
    fixMenuHandle(item) {
      const { icon, onclick } = item;
      const { title, action, url, width, options } = onclick;
      switch (action) {
        case "custom":
          console.log(url);
          break;

        case "openTab":
          let tabItem = {
            key: title,
            name: title,
            url: url,
            icon: icon,
          };
          this.addTab(tabItem);
          break;

        // 全局抽屉打开
        case "openDrawer":
          let currTab = null;
          if (options.helpUrl) {
            currTab =
              this.tabData.filter((tab) => {
                return tab.key == this.activeTabKey;
              })[0] || {};
          }

          this.changeDrawerInfo({
            title: title,
            drawerShow: true,
            drawerSrc: (currTab && currTab.helpUrl) || url,
            drawerWidth: width || "30%",
            options: options,
          });
          break;
        case "openBlank":
          // 判断是否开启了 帮助文档地址
          if (options.helpUrl) {
            let currTab =
              this.tabData.filter((tab) => {
                return tab.key == this.activeTabKey;
              })[0] || {};
            window.top.open(currTab.helpUrl || url);
          } else {
            window.top.open(url);
          }

          break;

        default:
          break;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.ekt-warp {
  .color-red {
    color: red;
  }
  .el-header {
    z-index: 100;
    background-color: #22242f;
    color: #333;
    height: 48px !important;
    text-align: center;
    line-height: 48px;
    padding: 0 12px 0 0;
  }

  .ekt-content {
    height: 100%;

    .ekt-content-menu {
      width: 256px;
      background-color: #fff;
      color: #333;
      height: 100%;
      overflow: visible;

      &.collapse-active {
        width: 256px;
        transition: width 0.5s;
      }
      &.collapse-close {
        width: 48px;
        transition: width 0.5s;

        /deep/ .menu-content {
          width: 0;
          padding: 0;
        }
      }
    }

    .ekt-content-main {
      position: relative;
      padding: 0;
      background-color: #f2f3f5;

      /deep/ .v-modal {
        top: 48px;
      }

      /deep/.el-drawer__wrapper {
        position: absolute;

        &.drawer-model {
          left: initial;
          overflow: initial;

          .el-drawer__container {
            position: absolute;
            left: initial;
            width: initial;

            .el-drawer {
              position: static;
            }
          }
        }

        .el-drawer__header {
          padding: 0 20px;
          margin-bottom: 0;
          line-height: 48px;
          font-size: 14px;
          font-weight: 500;
          color: #323233;
          border-bottom: 1px solid #f2f3f5;
        }

        .el-drawer__body {
          overflow: hidden;
        }
      }

      .el-drawer__wrapper + .v-modal {
        position: absolute;
      }

      /deep/.global-dialog {
        width: 580px;

        .el-dialog__header {
          border-bottom: 1px solid #ebedf0;
        }
        .el-dialog__body {
          height: auto;
          padding: 0;
        }
      }
    }

    .fix-menu {
      position: fixed;
      right: -20px;
      bottom: 60px;
      width: 40px;
      z-index: 999;
      transition: all 0.5s;

      .fix-btn-item {
        cursor: pointer;
        display: none;
        width: 40px;
        height: 40px;
        line-height: 40px;
        margin-top: 10px;
        border-radius: 100%;
        text-align: center;
        background-color: #ffffff;
        color: #313131;
        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.1),
          0 8px 10px 1px rgba(0, 0, 0, 0.06),
          0 3px 14px 2px rgba(52, 53, 67, 0.05);

        &.main {
          display: inline-block;
          color: #fff;
          background-color: #2984ee;
        }
      }

      &:hover {
        width: 72px;

        .fix-btn-item {
          display: inline-block;
        }
      }
    }
  }
}

.mainBody {
  height: calc(100% - 43px - 50px);
  overflow: scroll;
}
.global-drawer .el-drawer__body {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/QiDian/home/index.vue